import { useQueryClient, type QueryFilters } from '@tanstack/react-query';
import { useCallback } from 'react';

export const useInvalidateQueries = (): ((filters: QueryFilters[]) => Promise<void>) => {
  const queryClient = useQueryClient();

  return useCallback(
    async (filters: QueryFilters[]) => {
      if (filters.length === 0) return;
      await Promise.all(filters.map(async (filter) => queryClient.invalidateQueries(filter)));
    },
    [queryClient],
  );
};
